export const GET_STUDENT_REG_REQUEST_FOR_DISCOUNT = 'GET_STUDENT_REG_REQUEST_FOR_DISCOUNT';
export const GET_STUDENT_REG_SUCCESS_FOR_DISCOUNT = 'GET_STUDENT_REG_SUCCESS_FOR_DISCOUNT';
export const GET_STUDENT_REG_FAILURE_FOR_DISCOUNT = 'GET_STUDENT_REG_FAILURE_FOR_DISCOUNT';